import { useRef, useEffect } from 'react';
import { Canvas, useFrame } from '@react-three/fiber';
import * as THREE from 'three';
import { OrbitControls } from '@react-three/drei';

const InstancedBoxes = ({ count = 1000 }) => {
  // InstancedMesh의 참조
  const meshRef = useRef<THREE.InstancedMesh>(null);

  // 임시 객체들
  const tempObject = new THREE.Object3D();
  const tempColor = new THREE.Color();

  useEffect(() => {
    const instancedMesh = meshRef.current!;

    // 초기 위치와 색상 설정
    for (let i = 0; i < count; i++) {
      // 랜덤 위치 설정
      tempObject.position.set(Math.random() * 100 - 50, Math.random() * 100 - 50, Math.random() * 100 - 50);

      // 랜덤 회전
      tempObject.rotation.set(Math.random() * Math.PI, Math.random() * Math.PI, Math.random() * Math.PI);

      // 랜덤 크기
      const scale = 0.5 + Math.random() * 1;
      tempObject.scale.set(scale, scale, scale);

      // 행렬 업데이트
      tempObject.updateMatrix();

      // 인스턴스에 행렬 적용
      instancedMesh.setMatrixAt(i, tempObject.matrix);

      // 인스턴스별 색상 설정
      tempColor.setHSL(Math.random(), 0.5, 0.5);
      instancedMesh.setColorAt(i, tempColor);
    }

    // 변경사항 적용
    instancedMesh.instanceMatrix.needsUpdate = true;
    if (instancedMesh.instanceColor) instancedMesh.instanceColor.needsUpdate = true;
  }, [count]);

  // 애니메이션
  useFrame((state) => {
    const time = state.clock.getElapsedTime();
    const instancedMesh = meshRef.current!;

    for (let i = 0; i < count; i++) {
      // 각 인스턴스의 현재 행렬 가져오기
      instancedMesh.getMatrixAt(i, tempObject.matrix);
      // Matrix를 분해하여 위치, 회전, 크기 정보 추출
      tempObject.matrix.decompose(tempObject.position, tempObject.quaternion, tempObject.scale);

      // 회전 애니메이션
      tempObject.rotation.x = time * 0.1 + i * 0.1;

      // 행렬 업데이트
      tempObject.updateMatrix();
      instancedMesh.setMatrixAt(i, tempObject.matrix);
    }

    instancedMesh.instanceMatrix.needsUpdate = true;
  });

  return (
    <instancedMesh ref={meshRef} args={[undefined, undefined, count]}>
      <boxGeometry />
      <meshPhongMaterial />
    </instancedMesh>
  );
};

// 사용 예시
const Scene = () => (
  <Canvas>
    <ambientLight intensity={0.5} />
    <pointLight position={[10, 10, 10]} />
    <InstancedBoxes count={1000} />
    <OrbitControls />
  </Canvas>
);

export default Scene;
